module.exports = __webpack_public_path__ + "static/media/lob-member-3.c42f32b5.jpg";